export default __webpack_public_path__ + "img/23223815df1269b71ed18042cc075562.png";